// Load時処理
document.addEventListener('DOMContentLoaded', function() {

  if (document.querySelector('.js-load')) {
    document.querySelectorAll('.js-load').forEach(elm => {
      elm.classList.add('is-loaded');
    })
  }

  if (document.querySelector('.js-load-remove-init.init')) {
    document.querySelectorAll('.js-load-remove-init.init').forEach(elm => {
      elm.classList.remove('init');
    })
  }

})